import React, { useEffect, useRef } from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { useIsSidebarOpen } from '@shared/hooks';
import { Icon, UiButton, UiText } from '@shared/ui';

import cls from './TeamTrialBanner.module.css';

export const TeamTrialBanner = ({ classes }: { classes: string }) => {
    const { t } = useTranslation();
    const { isSidebarOpen, sidebarWidth } = useIsSidebarOpen();

    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const estimateNav = document.querySelector('.estimate-nav');
        const contentWrapper = document.querySelector('.content-wrapper');
        // @ts-ignore
        if (Array.isArray(modalData) && !Array.isArray(bannerData)) {
            // @ts-ignore
            contentWrapper.style.paddingTop = '60px';

            if (estimateNav) {
                if (!ref.current) return;

                ref.current.style.top = '88px';
            }
        } else {
            // @ts-ignore
            contentWrapper.style.padding = '1.5rem 1.7rem';

            if (estimateNav) {
                if (!ref.current) return;

                ref.current.style.top = '46px';
            }
        }
        // @ts-ignore
        contentWrapper.style.paddingTop = '60px';

        if (estimateNav) {
            if (!ref.current) return;

            ref.current.style.top = '88px';
        }
    }, []);

    return (
        <div
            ref={ref}
            className={cls.TeamTrialBannerWrapper}
            style={
                isSidebarOpen
                    ? {
                          left: `${sidebarWidth}px`,
                          width: `calc(100% - ${sidebarWidth}px)`,
                      }
                    : undefined
            }
        >
            <div className={cn(cls.TeamTrialBanner, [classes])}>
                <UiText tag="span" classes={cls.title}>
                    {t('TeamTrialBanner.return.UiText')}
                </UiText>
                <a className={cls.link} href="/company">
                    <UiButton
                        className={cls.button}
                        variant="text"
                        btnText={t('TeamTrialBanner.return.UiButton.btnText')}
                        endIcon={<Icon iconName="rightArrow" />}
                    />
                </a>
            </div>
        </div>
    );
};
